import { Injectable } from '@angular/core';
import { HttpClient,HttpParams } from '@angular/common/http';
import { Carrier} from '../carrier/carrier';
import { CompleteScanRequest } from '../carrier/completeScanRequest';
import { environment } from '../../environments/environment';
import { Observable, of } from 'rxjs';
import { ScannerInput } from './scanner-input';
import { LabMDM } from "../masterdata/models/lab";
import { BBResponseContainer } from './response-container';
import { PrintRequest } from './print-request';
import { Subject } from 'rxjs';
import { BuildInfo } from '../BuildInfo';
import { catchError, tap, timeout } from 'rxjs/operators';

@Injectable()
export class CarrierService {

  defaultTimeout = 600000;
  noValue = { data: { Build: { Number: 'N/A' } } };

  constructor(private http: HttpClient) { }

  getBuildInfo() {
    return this.http.get<BuildInfo>("/assets/TFS-Build-Report.json").pipe(catchError(error => of({ Build: { Number: 'unknown build' } })));
  }

  getServiceBuildInfo(serviceHostUrl: string) {
    let url = serviceHostUrl + "build";
    return this.http.get<BBResponseContainer>(url).pipe(catchError(error => of(this.noValue)));
  }

  getCarrierOld(): Observable<Carrier[]> {
    let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'carrier';
    return this.http.get<Carrier[]>(url).pipe(tap(event => { }, error => {
      error.url = url;
    }));
  }

  getCarrier(lab: LabMDM, startPage: number, fromDate: string, wipCheck: boolean, scCheck: boolean, lpCheck: boolean): Observable<BBResponseContainer> {
    let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'carrier';
    let requestParam = new HttpParams().set('labId', lab._id)
      .set('startPage', startPage.toString())
      .set('fromDate', fromDate)
      .set('wipStateCheck', String(wipCheck))
      .set('completeStateCheck', String(scCheck))
      .set('labProcessStateCheck', String(lpCheck));
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(this.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  getCarrierCount(lab: LabMDM, fromDate: string, wipCheck: boolean, scCheck: boolean, lpCheck: boolean): Observable<BBResponseContainer> {
    let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'carrier/count';
    let requestParam = new HttpParams().set('labId', lab._id)
      .set('fromDate', fromDate)
      .set('wipStateCheck', String(wipCheck))
      .set('completeStateCheck', String(scCheck))
      .set('labProcessStateCheck', String(lpCheck));
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(this.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  getcarrierById(id: string) {
    let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'carrier/' + id;
    return this.http.get<BBResponseContainer>(url).pipe(timeout(this.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }
  deleteCarrier(carrier: Carrier): Observable<BBResponseContainer> {
    let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'carrier/' + carrier._id;
    return this.http.delete<BBResponseContainer>(url).pipe(timeout(this.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  addCarrier(carr: Carrier) {
    let url: string = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + "carrier";
    return this.http.post<BBResponseContainer>(url, carr).pipe(timeout(this.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }


  GetCarriersByDate(date: Date) {
    return this.http.post<BBResponseContainer>(environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'carriersByDate', date);
  }

  getCarriersFromGenericScanner(lab: LabMDM, scannerType: string) {
    let scanInput: ScannerInput = { scannerType: scannerType, ScannerLocation: null, scannerName: null, simulation: false, lab: lab };
    let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'scan/';
    return this.http.post<BBResponseContainer>(url, scanInput).pipe(timeout(this.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  saveCarriers(carriers: Carrier[]) {
    let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'carrier'
    return this.http.post<BBResponseContainer>(url, carriers).pipe(timeout(this.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  saveCarrier(carrier: Carrier) {
    let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'carrier'
    return this.http.post<BBResponseContainer>(url, carrier).pipe(timeout(this.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  completeScan(completeScanRequest: CompleteScanRequest) {
    let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'completeScan';
    return this.http.post<BBResponseContainer>(url, completeScanRequest).pipe(timeout(this.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  hasDuplicateBarcode(barcode: string, lab: LabMDM): Observable<BBResponseContainer> {
    let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'carrier/checkDuplicate';
    let requestParam = new HttpParams().set('barcode', barcode)
      .set('labId', lab._id);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options);
  }

  updateCarrier(carrier: Carrier) {
    let url: string = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + "carrier";
    return this.http.put<BBResponseContainer>(url, carrier).pipe(timeout(this.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  updateCarrierState(carriers: Carrier[]) {
    let url: string = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + "carrier";
    return this.http.put<BBResponseContainer>(url, carriers);
  }


  createOrderProcessing(lab: LabMDM) {
    let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'createProcessingOrders';
    let requestParam = new HttpParams().set('labId', lab._id);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(this.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  public reprintLabel(printRequest: PrintRequest): Observable<BBResponseContainer> {
    let url = environment.BB_PRINT_SERVICE_URL + 'printLabel';
    return this.http.post<BBResponseContainer>(url, printRequest).pipe(timeout(this.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  public reExport(carrier: Carrier): Observable<BBResponseContainer> {
    let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'generateControllerFile';
    return this.http.post<BBResponseContainer>(url, carrier).pipe(timeout(this.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }
  //shared Methods
  // Observable string sources
  private emitChangeSource = new Subject<any>();
  // Observable string streams
  changeEmitted$ = this.emitChangeSource.asObservable();
  // Service message commands
  emitChange(change: any) {
    this.emitChangeSource.next(change);
  }

  public uploadStandatrdPrimer(formData: FormData): Observable<boolean> {
    let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'standardprimer';
    return this.http.post<any>(url, formData).pipe(timeout(this.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  public saveSRCarrier(carr: Carrier) {
    let url: string = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + "supreme-run";
    return this.http.post<BBResponseContainer>(url, carr).pipe(timeout(this.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  public saveHamiltonCarrier(carrier: Carrier) {
    let url: string = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + "hamiltonRack";
    return this.http.post<BBResponseContainer>(url, carrier).pipe(timeout(this.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }



  public emptyHamiltonRack(carrier: Carrier) {
    let url: string = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + "hamiltonRack/carrier";
    return this.http.post<BBResponseContainer>(url, carrier).pipe(timeout(this.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  public getTRTFile(barcode: string) {
    let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'tRTFile';
    let requestParam = new HttpParams().set('carrierBarcode', barcode);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(this.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }
}
